import { defineStore } from "pinia";
import { configuratorIdStore } from "./configuratorIdStore";
import { useConfiguratorStore } from "./configuratorData";
import { useLoginStore } from "./LoginStore";
import { BuildIdResponse } from "./types";
import { useAdditionalAttrStore } from "./AdditionalAttrStore";

export const useDataLayerStore = defineStore("dataLayer", {
  state: () => ({
    eventCalled: [],
  }),
  actions: {
    datalayerViewItem: async () => {
      const configuratorStore = useConfiguratorStore();

      const dataLayer = window.dataLayer || [];
      dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      dataLayer.push({
        event: "view_item",
        ecommerce: {
          item_list_id: "configurator_start",
          item_list_name: "configurator",
          items: [
            {
              item_id: configuratorStore.getCurrentType,
              item_name:
                configuratorStore.getCurrentState?.CurrentCoding[0].Description,
              affiliation: "WIKA Configurator",
              index: 0,
              item_brand: "WIKA",
              item_category:
                configuratorStore.getCurrentState?.CurrentCoding[0].Category,
              item_list_id: "configurator_start",
              item_list_name: "configurator",
              location_id: configuratorStore.getCurrentState?.CurrentLanguage,
              country: useAdditionalAttrStore().countryISO,
            },
          ],
        },
      });

      console.log(dataLayer);
    },

    dataLayerSelectItem: async () => {
      const configuratorStore = useConfiguratorStore();
      const dataLayer = window.dataLayer || [];
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "select_item",
        ecommerce: {
          item_list_id: "configurator_end",
          item_list_name: "configurator",
          items: [
            {
              item_id: configuratorStore.getCurrentType,
              item_name:
                configuratorStore.getCurrentState?.CurrentCoding[0].Description,
              affiliation: "WIKA Configurator",
              index: 0,
              item_brand: "WIKA",
              item_category:
                configuratorStore.getCurrentState?.CurrentCoding[0].Category,
              item_list_id: "configurator_end",
              item_list_name: "configurator",
              item_variant:
                configuratorStore.getCurrentState?.CurrentCoding[0]
                  .ContentString,
              location_id: configuratorStore.getCurrentState?.CurrentLanguage,
              country: useAdditionalAttrStore().countryISO,
            },
          ],
        },
      });
      console.log(dataLayer);
    },

    dataLayerAddToCart: async () => {
      const configuratorStore = useConfiguratorStore();
      const dataLayer = window.dataLayer || [];
      dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          item_list_id: "configurator_shop",
          item_list_name: "configurator",
          items: [
            {
              item_id: configuratorStore.getCurrentType,
              item_name:
                configuratorStore.getCurrentState?.CurrentCoding[0].Description,
              affiliation: "WIKA Configurator",

              index: 0,
              item_brand: "WIKA",
              item_category:
                configuratorStore.getCurrentState?.CurrentCoding[0].Category,
              item_list_id: "configurator_shop",
              item_list_name: "configurator",
              item_variant:
                configuratorStore.getCurrentState?.CurrentCoding[0]
                  .ContentString,
              location_id: configuratorStore.getCurrentState?.CurrentLanguage,
              country: useAdditionalAttrStore().countryISO,
            },
          ],
        },
      });
    },

    dataLayerConfiguratorStart: () => {
      const configuratorStore = useConfiguratorStore();
      const dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "configurator_start",
        type: configuratorStore.getCurrentType,
        type_name:
          configuratorStore.getCurrentState?.CurrentCoding[0].Description,
        type_cat: configuratorStore.getCurrentState?.CurrentCoding[0].Category,
        lng: configuratorStore.getCurrentState?.CurrentLanguage,
        country: useAdditionalAttrStore().countryISO,
        session: useLoginStore().getwebsession,
      });
      console.log(dataLayer);
    },

    dataLayerconfiguratorEnd: async () => {
      const configuratorStore = useConfiguratorStore();
      const dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "configurator_end",
        type: configuratorStore.getCurrentType,
        type_name:
          configuratorStore.getCurrentState?.CurrentCoding[0].Description,
        type_cat: configuratorStore.getCurrentState?.CurrentCoding[0].Category,
        lng: configuratorStore.getCurrentState?.CurrentLanguage,
        country: useAdditionalAttrStore().countryISO,
        order_code:
          configuratorStore.getCurrentState?.CurrentCoding[0]
            .ContentStringPublic,
        session: useLoginStore().getwebsession,
      });
      console.log(dataLayer);
    },

    dataLayerConfiguratorSetCriteria: () => {
      const configuratorStore = useConfiguratorStore();
      let criteriaDescription = "";
      if (
        configuratorStore.lastSelectedCriteriaOption &&
        configuratorStore.lastSelectedCriteriaOption
          ?.ConfiguratorOptionDescription
      ) {
        configuratorStore.getCurrentState?.CurrentCoding.forEach((item) => {
          item.Criterias.forEach((criteria) => {
            if (
              configuratorStore.lastSelectedCriteriaOption!.CriteriaIdx ==
              criteria.CriteriaIdx
            ) {
              criteriaDescription = criteria.Description;
            }
          });
        });
      }

      const dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "configurator_set_criteria",
        type: configuratorStore.getCurrentType,
        type_name:
          configuratorStore.getCurrentState?.CurrentCoding[0].Description,
        type_cat: configuratorStore.getCurrentState?.CurrentCoding[0].Category,
        lng: configuratorStore.getCurrentState?.CurrentLanguage,
        country: useAdditionalAttrStore().countryISO,
        criteria: criteriaDescription,
        criteria_value:
          configuratorStore.lastSelectedCriteriaOption
            ?.ConfiguratorOptionDescription,
        session: useLoginStore().getwebsession,
      });
      console.log(dataLayer);
    },

    // only here set the build ID
    dataLayerConfiguratorToShop: async () => {
      const configuratorStore = useConfiguratorStore();

      let generatebuildId = false;

      useAdditionalAttrStore().options.moreOptionButtonActions?.forEach(
        (action) => {
          if (action.pregenerateBuildId) {
            generatebuildId = true;
          }
        }
      );

      const build_id = generatebuildId
        ? ((await configuratorIdStore().getConfiguratorId()) as BuildIdResponse)
        : {
            data: {
              code: "",
            },
          };

      const dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "configurator_to_shop",
        type: configuratorStore.getCurrentType,
        type_name:
          configuratorStore.getCurrentState?.CurrentCoding[0].Description,
        type_cat: configuratorStore.getCurrentState?.CurrentCoding[0].Category,
        lng: configuratorStore.getCurrentState?.CurrentLanguage,
        country: useAdditionalAttrStore().countryISO,
        order_code:
          configuratorStore.getCurrentState?.CurrentCoding[0]
            .ContentStringPublic,
        build_id: build_id.data.code,
        session: useLoginStore().getwebsession,
      });
      console.log("configurator_to_shop ==> ", dataLayer);
    },
  },
});
